import React from "react";
import Checkbox from "@mui/material/Checkbox";
import StoreOutlinedIcon from "@mui/icons-material/StoreOutlined";


/**
 * Shared scope picker for bulk actions: radio between "all of their
 * memberships in this company" and "specific stores", with a checkbox
 * list when "specific" is selected. Each consumer wires its own
 * `(scope, storeIds, setScope, setStoreIds)` state.
 */
export default function ScopePicker({
  scope,
  setScope,
  storeIds,
  setStoreIds,
  companyStores,
  allLabel = "All of their memberships in this company",
  specificLabel = "Specific stores only",
  radioGroupName,
}) {
  const toggleStore = (id) => {
    setStoreIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  return (
    <div>
      <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-500 mb-2">
        Scope
      </p>
      <div className="space-y-1.5">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="radio"
            name={radioGroupName}
            value="all"
            checked={scope === "all"}
            onChange={() => setScope("all")}
            className="accent-violet-700"
          />
          <span className="text-sm text-slate-700">{allLabel}</span>
        </label>
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="radio"
            name={radioGroupName}
            value="stores"
            checked={scope === "stores"}
            onChange={() => setScope("stores")}
            className="accent-violet-700"
          />
          <span className="text-sm text-slate-700">{specificLabel}</span>
        </label>
      </div>

      {scope === "stores" && (
        <div className="mt-2 max-h-[180px] overflow-y-auto rounded-lg border border-slate-200">
          {companyStores.length === 0 && (
            <div className="px-3 py-6 text-center text-sm text-slate-500">No stores in this company.</div>
          )}
          {companyStores.map((s) => {
            const checked = storeIds.includes(s.id);
            const isClosed = s.status === "closed";
            return (
              <label
                key={s.id}
                className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-slate-50"
              >
                <Checkbox
                  checked={checked}
                  onChange={() => toggleStore(s.id)}
                  size="small"
                  sx={{ color: "#cbd5e1", "&.Mui-checked": { color: "#6d28d9" }, py: 0.5 }}
                />
                <StoreOutlinedIcon style={{ fontSize: 16 }} className="text-slate-400" />
                <span className={`text-sm ${checked ? "text-violet-800 font-medium" : "text-slate-700"}`}>
                  {s.store_name}
                </span>
                {isClosed && (
                  <span className="ml-auto px-1.5 py-0.5 text-[10px] uppercase tracking-wider rounded bg-slate-100 text-slate-500">
                    closed
                  </span>
                )}
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
}
